import { useEffect, useState, useCallback } from "react";
import { Box } from "@mui/material";
import CalculatorMobileLayout from "./mobile/calculatorMobileLayout";
import CalculatorWebLayout from "./web/calculatorWebLayout";
import SnackbarComponent from '../../../components/snackBar/snackbarComponent';
import { GetAuth } from '../../../context/auth/authProvider';
import { GetSitesAndActivityInfo } from "../../../context/calculator/sitesAndActivity/sitesAndActivityProvider";
import { useGetListOfSitesAndActivitiesMutation, useGetSelectedSitesAndActivityDetailsMutation } from "../../../services/sitesAndActivities";
import ErrorView from "../../error/errorView";

const SitesAndCalculatorLayout = ({
    navOption,
    setShowTabView
}) => {
    const [formView, setFormView] = useState(false);

    const [defaultData, setDefaultData] = useState({
        id: null,
        sites: [],
        activities: [],
        kids: 0,
        adults: 0
    });

    const [snackBar, setSnackBar] = useState({
        message: "",
        open: false,
        color: ""
    });

    const calculator = GetSitesAndActivityInfo();
    const auth = GetAuth();

    const [
        getAllSitesAndActivitiesList,
        {
            isLoading: isLoadingSitesAndActivities,
            isSuccess: isSuccessEditSitesAndActivities,
            data: tourSitesAndActivities,
            isError: isErrorEditSitesAndActivities,
            error: errorEditSitesAndActivities 
        }
    ] = useGetListOfSitesAndActivitiesMutation();

    useEffect(() => {
        getAllSitesAndActivitiesList({staffId: auth?.currentUser?.staffID});
    }, []);

    useEffect(() => {
        if(calculator.editSitesAndActivityData){
            console.log(calculator.editSitesAndActivityData);

            setDefaultData({
                id: calculator.editSitesAndActivityData.id,
                sites: calculator.editSitesAndActivityData.siteFees,
                activities: calculator.editSitesAndActivityData.activityFees,
                kids: calculator.editSitesAndActivityData.kidsCount,
                adults: calculator.editSitesAndActivityData.adultCount
            });

            calculator.updateName(calculator.editSitesAndActivityData.name);
        }
    }, []);

    const [
        getSelectedSitesAndActivityData, 
        {
            isLoading: isLoadingGetSelectedSiteAndActivityData,
            isSuccess: isSuccessGetSelectedSiteAndActivityData,
            data: selectedSiteAndActivityData,
            isError: isErrorGetSelectedSiteAndActivityData,
            error: errorGetSelectedSiteAndActivityData
        }
    ] = useGetSelectedSitesAndActivityDetailsMutation();

    useEffect(() => {
        if(selectedSiteAndActivityData){
            console.log(selectedSiteAndActivityData);

            calculator.updateSharedData(selectedSiteAndActivityData);

            setFormView(true);
            setShowTabView(false);
        }
    }, [selectedSiteAndActivityData]);
    
    useEffect(() => {
        if(isErrorGetSelectedSiteAndActivityData && errorGetSelectedSiteAndActivityData){
            console.log(errorGetSelectedSiteAndActivityData);
    
            setSnackBar({
                message: errorGetSelectedSiteAndActivityData?.data?.message ?? "Something went wrong!",
                color: "red",
                open: true
            });
        }
    }, [isErrorGetSelectedSiteAndActivityData, errorGetSelectedSiteAndActivityData]);

    const moveToFormView = useCallback((sites, activities, kids, adults) => {
        console.log("Sites: " + sites + ", Activities: " + activities + ", Kids: " + kids + ", Adults: " + adults);

        let id = null;

        if(calculator.editSitesAndActivityData){
            id = calculator.editSitesAndActivityData.id
        }

        console.log("Id: " + id);

        setDefaultData({
            id: id,
            sites: sites,
            activities: activities,
            kids: kids,
            adults: adults
        });

        calculator.updateFiltersData(sites, activities, kids, adults, id);

        getSelectedSitesAndActivityData({activityIds: activities, siteIds: sites, staffId: auth?.currentUser?.staffID});
    }, [calculator]);
        
    const backToFilterView = useCallback((data, reset=false) => {
        console.log(calculator.editSitesAndActivityData);
        console.log(data);

        if(reset){
            setDefaultData({
                id: null,
                sites: [],
                activities: [],
                kids: 0,
                adults: 0
            });
        }
        else if(data){
            setDefaultData({
                id: data.id,
                sites: data.siteFees,
                activities: data.activityFees,
                kids: data.kidsCount,
                adults: data.adultCount
            });

            calculator.updateName(data.name);
        }

        setFormView(false);
        setShowTabView(true);
    }, [calculator]);

    return (
        <>
            <Box
                width='100%'
            >
                {
                    isErrorEditSitesAndActivities
                    ?
                    <ErrorView 
                        icon="/images/error.png"
                        errorTitle={errorEditSitesAndActivities?.status ?? "Unknown Error"}
                        errorDescription={errorEditSitesAndActivities?.data?.message ?? "Something went wrong!"}
                        height="50vh"
                    />
                    :
                    <>
                        <Box 
                            sx={{
                                display: {xs: 'block', lg: 'none'}
                            }}
                        >
                            <CalculatorMobileLayout 
                                formView={formView}
                                defaultData={defaultData}
                                backToFilterView={backToFilterView}
                                moveToFormView={moveToFormView}
                                buttonLoading={isLoadingGetSelectedSiteAndActivityData}
                                dropDownDataLoading={isLoadingSitesAndActivities}
                                tourSitesAndActivities={tourSitesAndActivities}
                            />
                        </Box>

                        <Box 
                            sx={{
                                display: {xs: 'none', lg: 'block'},
                                pb: 5
                            }}>
                            <CalculatorWebLayout 
                                navOption={navOption}
                                formView={formView}
                                defaultData={defaultData}
                                backToFilterView={backToFilterView}
                                moveToFormView={moveToFormView}
                                buttonLoading={isLoadingGetSelectedSiteAndActivityData}
                                dropDownDataLoading={isLoadingSitesAndActivities}
                                tourSitesAndActivities={tourSitesAndActivities}
                            />
                        </Box>   
                    </>
                }
            </Box>

            <SnackbarComponent 
                message={snackBar.message}
                color={snackBar.color}
                open={snackBar.open}
                handleClose={() => setSnackBar({
                    message: "",
                    open: false
                })}
            />
        </>
    );
}

export default SitesAndCalculatorLayout;